export default __webpack_public_path__ + "static/media/slide2.d1ba4871.png";